import './style.scss';
import { ListItem } from 'views/mutual/list';
import { SubUserListItemFragment } from 'views/utils/graphql/graphql';

// ID含めるとエラーになるので一時的にコメントアウト
export type SubUserListItemProps = {
  itemIndex: number;
  subUser: SubUserListItemFragment;
  onDelete: (id: string) => void;
};

export const SubUserListItem = (props: SubUserListItemProps) => {
  const { itemIndex, subUser, onDelete } = props;
  return (
    <ListItem itemIndex={itemIndex} className="subUserListItem">
      <div className="subUserListItem_id">{subUser.Branch}</div>
      <div className="subUserListItem_email">{subUser.MailAddress}</div>
      <div className="subUserListItem_delete">{<button onClick={() => onDelete(subUser.Branch)}>削除</button>}</div>
    </ListItem>
  );
};

export type SubUserListProps = {
  items: Array<SubUserListItemFragment | null>;
  onDelete: (id: string) => void;
};
export const SubUserList = ({ items, onDelete }: SubUserListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <SubUserListItem key={index} itemIndex={index} subUser={item!} onDelete={onDelete} />
        ))}
    </>
  );
};
